import React from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { Unmasked } from '@apollo/client/masking';
import { PopularRequestsList, PopularRequestsSection } from './styled';
import { NewSectionHeader } from '../NewSectionHeader';
import { getKeywords } from '../../api/queries';
import { KeywordsQuery } from '../../graphql/graphql';

export const PopularRequests: React.FC = () => {
  const { data } = useQuery<Unmasked<KeywordsQuery>>(getKeywords);
  const { t, i18n } = useTranslation();

  const keywords = data?.keywords || [];

  const hasKeywords = !!keywords.length && i18n.language !== 'ru';

  if (!hasKeywords) {
    return null;
  }

  return (
    <PopularRequestsSection>
      <NewSectionHeader
        title={t('sections.popular_requests.title')}
        cypress="popular-requests-section-title"
      />
      <PopularRequestsList>
        {keywords.map(({ id, term, url }) => (
          <li key={id}>
            <a target="_blank" rel="noopener noreferrer" href={url || '#'}>
              {term}
            </a>
          </li>
        ))}
      </PopularRequestsList>
    </PopularRequestsSection>
  );
};
